export default {
    title: 'Equipment',
    actions: {
        add: 'Add Equipment',
        edit: 'Edit',
        delete: 'Remove Equipment',
        copyId: 'Copy Equipment ID',
        update: 'Update Equipment'
    },
    columns: {
        name: 'Name',
        description: 'Description',
        unit: 'Unit',
        sku: 'SKU',
        sellingPrice: 'Selling Price',
        account: 'Account',
        costPrice: 'Cost Price',
        expenseAccount: 'Expense Account',
        type: 'Type',
        qboItem: 'QuickBooks Item'
    },
    placeholder: {
        selectQboItem: 'Select QuickBooks Item',
        none: 'None'
    },
    types: {
        antenna: 'Antenna',
        router: 'Router',
        cable: 'Cable',
        other: 'Other'
    },
    dialog: {
        add: {
            title: 'Add New Equipment',
            description: 'Enter the details for the new equipment here. Click save when you\'re done.'
        },
        update: {
            title: 'Update Equipment',
            description: 'Update the details for this equipment. Click save when you\'re done.'
        },
        save: 'Save changes'
    },
    notifications: {
        idCopied: {
            title: 'Equipment ID Copied',
            description: 'The equipment ID has been copied to your clipboard.'
        },
        deleted: {
            title: 'Equipment Deleted',
            description: 'The equipment has been successfully deleted.'
        },
        error: {
            title: 'Error',
            description: 'Failed to delete the equipment. Please try again.'
        }
    }
}
